export default __webpack_public_path__ + "static/media/logo.63f00b13.ico";